// toast.ts — 自研轻量瞬态提示核心（2026-09-09 替换 vue-sonner）
// 规范：见根 .commandcode/rules/ui-skills.md「三-bis、瞬态提示规范」。
//  - 一次性操作反馈走这里（成功/服务端整体错误/警示/中性通知）
//  - 表单规则校验错误 → 字段级红字，不经过 toast
//  - 顶部居中 fixed 浮层（由 YfbToast.vue 渲染），hover 暂停、可点 X 关闭、最多堆叠 3 条
import { reactive } from 'vue'

export type ToastType = 'success' | 'error' | 'info' | 'warning'

export interface ToastItem {
  id: number
  type: ToastType
  message: string
  duration: number
  /** 关闭/超时移除前通知组件播退出动画 */
  leaving?: boolean
}

const MAX_STACK = 3
// 2026-09-09 交互优化：统一 3s（成功/信息/错误/警告一致），纯自动消失、无关闭按钮/hover 暂停
export const DEFAULT_DURATION: Record<ToastType, number> = {
  success: 3000,
  info: 3000,
  error: 3000,
  warning: 3000
}

export const toasts = reactive<ToastItem[]>([])

let seq = 0
const timers = new Map<number, ReturnType<typeof setTimeout>>()

export function pushToast(type: ToastType, message: string, duration?: number): number {
  // 超过堆叠上限：移除最早一条（立刻，不播退出动画，避免挤占）
  while (toasts.length >= MAX_STACK) {
    const oldest = toasts.shift()
    if (oldest) clearTimer(oldest.id)
  }
  const id = ++seq
  toasts.push({ id, type, message, duration: duration ?? DEFAULT_DURATION[type] })
  armTimer(id)
  return id
}

export function removeToast(id: number): void {
  const idx = toasts.findIndex((t) => t.id === id)
  if (idx === -1) return
  clearTimer(id)
  toasts[idx].leaving = true
  // 等退出动画（200ms）后再真正出队
  setTimeout(() => {
    const i = toasts.findIndex((t) => t.id === id)
    if (i !== -1) toasts.splice(i, 1)
  }, 200)
}

export function clearToasts(): void {
  for (const t of [...toasts]) removeToast(t.id)
}

/** hover 暂停/恢复（组件在 mouseenter/mouseleave 调用）——2026-09-09 起纯自动消失，已不再使用 */
export function pauseToast(_id: number): void {}

export function resumeToast(_id: number): void {}

function armTimer(id: number): void {
  clearTimer(id)
  const item = toasts.find((t) => t.id === id)
  if (!item || item.leaving) return
  timers.set(
    id,
    setTimeout(() => removeToast(id), item.duration)
  )
}

function clearTimer(id: number): void {
  const h = timers.get(id)
  if (h) {
    clearTimeout(h)
    timers.delete(id)
  }
}